import { useNavigate } from "react-router-dom";
import { ReportsMineData } from "../types/reportsMine.type";
import { ArrowBigRight } from "lucide-react";
import { useId } from "react";
import { Tooltip } from "react-tooltip";

export interface ReportsGridItemProps {
  report: ReportsMineData;
}

const ReportsGridItem = ({ report }: ReportsGridItemProps) => {
  const navigate = useNavigate();
  const uniqueId = useId();

  const maxPreviewDescriptionLength = 110

  const fullText = report?.description || '';
  const lastWordSpaceIndex = fullText.slice(0, maxPreviewDescriptionLength)?.lastIndexOf(' ')
  const shortText = fullText.length > maxPreviewDescriptionLength ? `${fullText.slice(0, lastWordSpaceIndex)}...` : fullText;
  
  return (
    <div
      key={report.id} className="flex flex-col justify-between bg-white-200 rounded-lg p-4 gap-4 h-[200px] cursor-pointer"
      onClick={() => navigate(`/reports/create?generator_klass=${report.generator_klass}`)}
    >
      <div className="flex flex-col gap-4">
        <div>
          <p className="text-xs font-light italic">
            Título do relatório
          </p>

          <p className="text-sm">
            {report.title || '--'}
          </p>
        </div>

        <div>
          <p className="text-xs font-light italic">
            Descrição do relatório
          </p>

          <p
            data-tooltip-id={uniqueId}
            data-tooltip-place="top"
            data-tooltip-html={fullText}
            className="text-sm text-ellipsis line-clamp-2"
          >
            {shortText || '--'}
          </p>
          {fullText.length > maxPreviewDescriptionLength && (
            <Tooltip
              id={uniqueId}
              className="z-50 max-w-[500px] whitespace-pre-wrap break-words bg-[#1f1f1f] p-4 border border-gray-700 text-white-900 text-sm"
            />
          )}
        </div>
      </div>

      <div className="flex justify-end items-center">
        <ArrowBigRight />
      </div>
    </div>
  );
}

export default ReportsGridItem;
